module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-400-48.8b5ab98.woff2";